import React, {useEffect, useState} from "react"
import {Theme} from "@mui/material/styles"
import {SelectChangeEvent, useTheme, MenuItem, MenuProps} from "@mui/material"
import {Sorting} from "../../../../../models/Sorting"
import {Cashmere25StyledSelectSort} from "./components"
import {getSXMenuProps} from "../../../components"

export interface Cashmere25SelectSortProps {
    value: string | undefined
    onChange: ((event: SelectChangeEvent<unknown>, child: React.ReactNode) => void) &
        React.FormEventHandler<HTMLDivElement>
    open: boolean
    onOpen: () => void
    onClose: () => void
    ref: React.RefObject<HTMLDivElement>
    toggleDropdown: () => void
    sortOptions: Sorting
}

export const Cashmere25SelectSort = ({
    value,
    onChange,
    open,
    ref,
    toggleDropdown,
    sortOptions,
}: Cashmere25SelectSortProps) => {
    const theme = useTheme()
    const getLocalSXMenuProps = (isHovered: boolean, theme: Theme) => {
        const baseProps = getSXMenuProps(isHovered, theme)
        const isRTL = theme.direction === "rtl"
        return {
            ...baseProps,
            // Add these two properties to align the menu to the right
            anchorOrigin: {
                vertical: "bottom",
                horizontal: isRTL ? "left" : "right", // Adjust for RTL
            },
            transformOrigin: {
                vertical: "top",
                horizontal: isRTL ? "left" : "right", // Adjust for RTL
            },
            PaperProps: {
                sx: {
                    ...baseProps.PaperProps?.sx,
                    marginTop: "3px",
                    marginRight: "-1px",
                    minWidth: "150px",
                    "& .MuiMenuItem-root": {
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        minWidth: "unset",
                    },
                },
            },
        }
    }

    const [sxMenuProps, setSxMenuProps] = useState(getLocalSXMenuProps(false, theme))

    useEffect(() => {
        setSxMenuProps(getLocalSXMenuProps(false, theme))
    }, [open, theme])

    return (
        <Cashmere25StyledSelectSort
            value={value}
            onChange={onChange}
            open={open}
            onOpen={toggleDropdown}
            onClose={toggleDropdown}
            MenuProps={sxMenuProps as any as MenuProps}
            ref={ref}
            renderValue={() => "Sort"}
            label="Sort"
            labelId="desktop-sort-select-label"
            id="desktop-sort-select"
            notched={false}
            data-testid="plp-desktop-sort-button"
        >
            {sortOptions?.options.map(opt => (
                <MenuItem
                    value={opt.value}
                    key={opt.value}
                    onMouseOver={() => setSxMenuProps(getLocalSXMenuProps(sortOptions.selected !== opt.value, theme))}
                    sx={{
                        paddingLeft: "12px",
                        paddingRight: "12px",
                    }}
                >
                    <span>{opt.name}</span>
                </MenuItem>
            ))}
        </Cashmere25StyledSelectSort>
    )
}

export default Cashmere25SelectSort
